export enum RetentionPeriod{
    TwoWeekly,
    Monthly,
    SixMonthly,
    Yearly
}